export class ErrorMessageProps {
    constructor(public message: string = '', public detail: string = '') {}
}
